import { render, staticRenderFns } from "./MedicationRequestModal.vue?vue&type=template&id=025706de&"
import script from "./MedicationRequestModal.vue?vue&type=script&lang=js&"
export * from "./MedicationRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports